import type { PlainGeofence, PointOnMap } from '@cobliteam/common-types/src/geofenceV3';
import type { StateCreator } from 'zustand';
import type { MonitoringSlices } from '.';

export interface GeofenceSliceState {
  geofenceToEdit?: PlainGeofence;
  pointOnMap: PointOnMap | undefined;
  showGeofenceTour: boolean;
  showGeofenceConfig: boolean;
  deleteGeofenceDrawing: boolean;
  hideGeofenceToEdit?: PlainGeofence;
  geofenceFormType: 'region' | 'drawing' | undefined;
  setGeofenceFormType: (geofenceFormType: 'region' | 'drawing' | undefined) => void;
  setGeofenceToEdit: (geofence?: PlainGeofence) => void;
  setPointOnMap: (point: PointOnMap) => void;
  clearGeofenceToEdit: () => void;
  clearPointOnMap: () => void;
  setHideGeofenceToEdit: (geofence?: PlainGeofence) => void;
  setDeleteGeofenceDrawing: (enable: boolean) => void;
}

type StateCreatorGeofence = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], GeofenceSliceState>;

const createGeofencesSlice: StateCreatorGeofence = (set) => ({
  geofenceToEdit: undefined,
  pointOnMap: undefined,
  showGeofenceTour: false,
  showGeofenceConfig: false,
  deleteGeofenceDrawing: false,
  geofenceFormType: undefined,
  hideGeofenceToEdit: undefined,
  setGeofenceFormType: (geofenceFormType: 'region' | 'drawing' | undefined) => set({ geofenceFormType }),
  setGeofenceToEdit: (geofence?: PlainGeofence) => set({ geofenceToEdit: geofence }),
  setPointOnMap: (point: PointOnMap) =>
    set((state) => ({
      pointOnMap: { ...state.pointOnMap, ...point },
    })),
  clearGeofenceToEdit: () => set({ geofenceToEdit: undefined }),
  clearPointOnMap: () => set({ pointOnMap: undefined }),
  setDeleteGeofenceDrawing: (enable: boolean) => set({ deleteGeofenceDrawing: enable }),
  setHideGeofenceToEdit: (geofence?: PlainGeofence) => set({ hideGeofenceToEdit: geofence }),
});

export default createGeofencesSlice;
